export const isFloat = (mixedVar: number) =>
  +mixedVar === mixedVar && (!isFinite(mixedVar) || !!(mixedVar % 1));
